import { render, staticRenderFns } from "./input-tags.vue?vue&type=template&id=1a16e586&scoped=true&"
import script from "./input-tags.vue?vue&type=script&lang=js&"
export * from "./input-tags.vue?vue&type=script&lang=js&"
import style0 from "./input-tags.vue?vue&type=style&index=0&id=1a16e586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a16e586",
  null
  
)

export default component.exports